import React, { useContext } from 'react';
import { AppUserManagementContext } from '../cnr/contexts/AppUserManagementContext';
import { showAppManagementTypes } from '../cnr/reducers/AppUserManagementReducer';
import UserAuths from '../components/user/UserAuths';
import JsonViewer from '../components/viewers/JsonViewer';
import FullPageWrapper from '../wrappers/FullPageWrapper';
import AppUserView from "./AppUserView";
import UiSaveButtons from '../components/buttons/UiSaveButtons';
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper';
import { clickOriginTypes } from '../enums/globalEnums';
import TreeViewer from '../components/viewers/TreeViewer';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { useClientProfiles } from 'global/cnr/contexts/useHelpers/useClientProfiles';
import { Icon, ItemMeta } from 'semantic-ui-react';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares ';

const AppUserSubManager = (props) => {

  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const { clickOriginType, ignoreFullPage, appManagementType } = props

  let _fromDataViewer;

  switch (clickOriginType) {
    case clickOriginTypes.dataViewer:
      _fromDataViewer = true
    default:
    //nothing
  }

  if (ignoreFullPage) {
    _fromDataViewer = true
  }


  // appUserManagementContext
  const appUserManagementContext = useContext(AppUserManagementContext)
  const { appUserManagement_state, appUserManagement_handlers } = appUserManagementContext ?? {}
  const { confirmation, currentUserCounts, filteredItems, selectedItems, updating } = appUserManagement_state ?? {}
  const { handleChange_appManagementType: hc_amt } = appUserManagement_handlers ?? {}

  const { clientProfiles: clientProfiles, updateClientProfiles } = useClientProfiles({ appManagementType })
  const { profiles_combined, profiles_delete } = clientProfiles ?? {}

  const _selectedItems = filteredItems ? filteredItems : selectedItems

  const handleUpdate_clientProfiles = async () => {
    appUserManagement_handlers.handleStartUpdate()
    await updateClientProfiles(profiles_combined, false)
    appUserManagement_handlers.handleStopUpdate()
  }

  const handleUpdate_clientProfilesMerge = async () => {
    appUserManagement_handlers.handleStartUpdate()
    updateClientProfiles(profiles_combined, true)
    appUserManagement_handlers.handleStopUpdate()
  }

  const handleUpdate_clientProfilesRemove = async () => {
    appUserManagement_handlers.handleStartUpdate()
    updateClientProfiles(profiles_delete, false, true)
    appUserManagement_handlers.handleStopUpdate()
  }

  const handleSendGsc = () => {
    // appUserManagement_handlers.handleStartUpdate()
    fn_cls.sendScheduledNotifications_gcs_direct()
  }

  const fnAltContent = (item) => {
    const { events } = item ?? {}
    const inEvent = events?.[pathViews.events] ? true : false
    return <Icon name={inEvent ? 'check circle' : 'circle outline'} color={inEvent ? 'green' : 'grey'} />
  }


  const wrapper_clientProfile = () => <Wrapper
    // header={'Confirmation (Update Client Profile Collection)'}
    content={<ItemMenuSquares imsType={_imsTypes.inline} menuItems={_.sortBy(profiles_combined, 'lastName')} fn_altContent={fnAltContent} />}
    // content={<TreeViewer data={profiles_combined} showSelected={true} />}
    footer={<UiSaveButtons
      save={{ caption: 'Update Client Profiles (ausm)', icon: 'save', oc: handleUpdate_clientProfiles }}
      preview={{ caption: 'Merge', oc: handleUpdate_clientProfilesMerge }}
      delete={{ caption: 'Remove Invalid', oc: handleUpdate_clientProfilesRemove }}
    />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    confirmation={confirmation}
  />

  const gcNotifications_wrapper = () => <Wrapper
    content={'Are you sure you want to send Gcs'}
    footer={<UiSaveButtons save={{ caption: 'Send', oc: handleSendGsc }} />}
    wrapperType={wrapperTypes.padded}
    updating={updating}
    confirmation={confirmation}
  />

  const fpw_appUserCount = () => <FullPageWrapper
    content={<JsonViewer json={currentUserCounts} />}
    handleCancel={hc_amt}
    topperCaption={'App User Counts'}
    isBack={true}
    fullMode={_fromDataViewer ? true : false}
  />

  const fpw_authorization = () => <FullPageWrapper
    content={<UserAuths />}
    handleCancel={hc_amt}
    topperCaption={'Authorization Check'}
    isBack={true}
    fullMode={_fromDataViewer ? true : false}
  />

  const fpw_add = () => <FullPageWrapper
    content={'Add Content'}
    handleCancel={hc_amt}
    topperCaption={'Add'}
    isBack={true}
    fullMode={_fromDataViewer ? true : false}
  />

  const fpw_email = () => <FullPageWrapper
    content={<AppUserView ignoreInverted={true} selectedItems={_selectedItems} />}
    handleCancel={hc_amt}
    topperCaption={'Send Emails'}
    isBack={true}
    fullMode={_fromDataViewer ? true : false}
  />

  const fpw_gcNotifications = () => <FullPageWrapper
    content={gcNotifications_wrapper()}
    handleCancel={hc_amt}
    topperCaption={'Send Gcs'}
    fullMode={_fromDataViewer ? true : false}
  />

  const fpw_clientProfiles = () => <FullPageWrapper
    content={wrapper_clientProfile()}
    handleCancel={hc_amt}
    topperCaption={'Update Client Profiles (ausm)'}
    isBack={true}
    fullMode={_fromDataViewer ? true : false}
  />

  const content = () => {
    switch (appManagementType) {
      case showAppManagementTypes.appUserCount:
        return fpw_appUserCount()
      case showAppManagementTypes.auth:
        return fpw_authorization()
      case showAppManagementTypes.add:
        return fpw_add()
      case showAppManagementTypes.email:
        return fpw_email()
      case showAppManagementTypes.gcNotifications:
        return fpw_gcNotifications()
      case showAppManagementTypes.updateAppUserProfiles:
      case showAppManagementTypes.updateClientProfiles:
        return fpw_clientProfiles()
      case showAppManagementTypes.getClientProfiles:
        return wrapper_clientProfile()
      default:
        return <div>{appManagementType}</div>
    }
  }

  return content()

}

export default AppUserSubManager